import React from 'react';
import Link from './Link';
import classnames from 'classnames';
import './Navigation.scss';
import PhoneNumber from './PhoneNumber';
import Modal from './Modal';

const PAGES = [
  { name: 'Home', path: '/', isHome: true },
  { name: 'Availabilities', path: '/availability' },
  { name: 'Building', path: '/building' },
  { name: 'Apartments', path: '/apartments' },
  { name: 'Neighborhood', path: '/neighborhood' },
  { name: 'Developer', path: '/developer' },
];

export default class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftNavIsOpen: false,
    };

    this.openLeftNav = this.openLeftNav.bind(this);
    this.closeLeftNav = this.closeLeftNav.bind(this);
  }

  openLeftNav() {
    this.setState({ leftNavIsOpen: true });

    let topNav = document.getElementsByClassName(
      'global-layout__navigation'
    )[0];
    if (!topNav.className.includes('global-layout__navigation--top'))
      topNav.className += ' global-layout__navigation--top';

    document
      .querySelector('.global-layout')
      .classList.add('global-layout--fixed');
  }

  closeLeftNav() {
    this.setState({ leftNavIsOpen: false });

    let reg = new RegExp(
        '(\\s|^)' + 'global-layout__navigation--top' + '(\\s|$)'
      ),
      topNav = document.getElementsByClassName('global-layout__navigation')[0];

    topNav.className = topNav.className.replace(reg, ' ');

    document
      .querySelector('.global-layout')
      .classList.remove('global-layout--fixed');
  }

  render() {
    const navComponentClassNames = classnames('navigation', {
      'navigation--left-nav-open': this.state.leftNavIsOpen,
      'navigation--right-nav-open': this.props.isContactModalActive,
    });

    // To understand why the drawer close icons don't call closeLeftNav and
    // closeContactModal, see commit b56e11b405d1e26493b52de56885cb09071bbc3e
    return (
      <nav className={navComponentClassNames}>
        <h1 className="navigation__site-title">300 Ashland</h1>
        <div className="navigation__drawer-icons-container navigation__left-drawer-icons">
          <button
            className="navigation__drawer-icon navigation__open-drawer-icon icon-hamburger"
            onClick={this.openLeftNav}
            aria-label={'Open Navigation'}
            title={'Open Navigation'}
            onKeyPress={this.openLeftNav}
          ></button>
          <button className="navigation__drawer-icon navigation__close-drawer-icon icon-close"></button>
        </div>
        <div className="navigation__drawer-icons-container navigation__right-drawer-icons">
          <button
            className="navigation__drawer-icon navigation__open-drawer-icon icon-contact-us"
            onClick={this.props.openContactModal}
            aria-label={'Open Contact us Modal'}
            title={'Open Contact us Modal'}
            onKeyPress={this.props.openContactModal}
          ></button>
          <button
            aria-label={'Close Contact us Modal'}
            aria-label={'Close Navigation'}
            title={'Close Navigation'}
            className="navigation__drawer-icon navigation__close-drawer-icon icon-close"
          ></button>
        </div>
        <div className="navigation__links-container">
          <ul className="navigation__page-links">{makeNavPagesLis(PAGES)}</ul>
          <ul className="navigation__cta-links">
            <li className="navigation__cta-link navigation__cta-link--black">
              <PhoneNumber format="periods" />
            </li>
            <li className="navigation__cta-link">
              <a
                className="button button--elongated"
                tabIndex="0"
                onClick={this.props.openScheduleTourModal}
                onKeyPress={this.props.openScheduleTourModal}
              >
                Book A Tour
              </a>
            </li>
          </ul>
        </div>
        <Modal
          id="navigationMobileModal"
          className="navigation__mobile-left-drawer"
          noCloseButton={true}
          isOpened={this.state.leftNavIsOpen}
          onClose={this.closeLeftNav}
          variants={['as-nav-drawer']}
          role={'dialog'}
          persistent={true}
        >
          <ul
            className="navigation__page-links"
            key="navigation__mobile-left-drawer"
          >
            {makeNavPagesLis(PAGES, this.closeLeftNav)}
          </ul>
        </Modal>
      </nav>
    );
  }
}

function makeNavPagesLis(pages, onClick) {
  return pages.map((page) => (
    <li
      className={classnames({ 'home-li': page.isHome })}
      key={page.path}
      aria-label={page.name}
    >
      <Link
        to={page.path}
        onlyActiveOnIndex={Boolean(page.isHome)}
        activeClassName="active"
        onClick={onClick}
      >
        {page.name}
      </Link>
    </li>
  ));
}



// WEBPACK FOOTER //
// ./client/components/Navigation.js